// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M20 20h-3v-4h3ZM7 16v4H4v-4Zm5-14A10 10 0 0 0 2 12v9a1 1 0 0 0 1 1h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H4v-2a8 8 0 0 1 16 0v2h-3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a1 1 0 0 0 1-1v-9A10 10 0 0 0 12 2Z"
    />
  </BaseIcon>
)
